import { Focusable, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import moment from 'moment';

type Format = 'L' | 'LL' | 'LLL' | 'LLLL';

type TimeProps = Readonly<{
  datetime: Date | string | number;
  format: Format;
  utc?: boolean;
  fromNow?: boolean;
  color?: string;
}>;

export const Time = ({ datetime, format, utc, fromNow, color }: TimeProps) => {
  const dt = utc ? moment.utc(datetime) : moment(datetime);
  const display = fromNow ? dt.fromNow() : dt.format(format);
  const hexcolor = color || '#000';

  return (
    <TooltipTrigger>
      <Focusable>
        <time
          dateTime={typeof datetime === 'string' ? datetime : datetime.toString()}
          color={hexcolor}
          // oxlint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role -- making this a real button is a UX change, out of scope here
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
        >
          {display}
        </time>
      </Focusable>
      <Tooltip placement="top" variant="popover">
        {dt.format('LLLL')}
      </Tooltip>
    </TooltipTrigger>
  );
};
